import React, {PropTypes} from 'react';
import {Row, Col} from 'antd'
import './Line.css'

const Line = ({children, onClick, className}) => {
  return (
    <div className={"Line" + " " + className} onClick={onClick}>
      <Row type="flex" justify="space-between" align="middle">
        {children}
      </Row>
    </div>
  );
}

export default Line;



// WEBPACK FOOTER //
// ./src/core/Line.js